import { createTheme } from '@mui/material/styles';

const theme = createTheme({
	palette: {
		primary: {
			main: '#4F46E5',
			light: '#818CF8',
			dark: '#3730A3',
			contrastText: '#ffffff',
		},
		secondary: {
			main: '#8B5CF6',
		},
		success: {
			main: '#22C55E',
		},
		background: {
			default: '#F8FAFC',
			paper: '#FFFFFF',
		},
	},
	typography: {
		fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
		h3: { fontWeight: 700, letterSpacing: '-0.5px' },
		h6: { fontWeight: 600 },
		body1: { lineHeight: 1.7 },
	},
	shape: {
		borderRadius: 12,
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					'& .MuiOutlinedInput-root': {
						borderRadius: 10,
					},
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: { backgroundImage: 'none' },
			},
		},
		MuiButton: {
			styleOverrides: {
				root: { borderRadius: 10, textTransform: 'none', fontWeight: 600 },
			},
		},
	},
});

export default theme;
